import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import styles from './changeCompanySize.module.scss';
import { Button, WithSpinner, InputWithTextInline } from '../../components';
import { actions } from '../../state/actions';
import swal from 'sweetalert';
import { Api } from './../../api/api';
import { config } from './../../api/config';
import { isSumValid2 } from './../../utils/auth/validations';
// import { errorhandle } from '../../utils/helpers/helpers';

const ChangeCompanySize = ({ open, requestId, loading, dispatch }) => {
  const [isLoading, setIsloading] = useState(false);
  const [notValid, setNotValid] = useState(false);
  const [companySizeTypeIdInvega, setCompanySizeTypeIdInvega] = useState(null);

  const cancel = () => {
    //setNotValid(false);
    setCompanySizeTypeIdInvega(null);

    const open = {
      modalName: 'changeCompanySize',
      visible: false,
    };
    dispatch(actions.modals.setModalVisibleFlagAction(open));
  };

  const yes = () => {
    setNotValid(true);
    if (companySizeTypeIdInvega !== null) {
      setIsloading(true);

      fetch(Api.API_BASE_URL + config.API_ENDPOINTS.SetCompanySizeType, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${window.localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          RequestId: requestId,
          companySizeTypeId: companySizeTypeIdInvega,
        }),
      })
        .then((res) => {
          if (res.ok === true) {
            dispatch(actions.backoffice.getRequestAction(requestId));
            cancel();

            swal({
              title: 'Duomenys sėkmingai išsaugoti',
              icon: 'success',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn btn-pink',
                  closeModal: true,
                },
              },
            });
          } else if (res.status === 403) {
            swal({
              title: `Šiam veiksmui atlikti neturite reikiamų teisių. Kreipkitės į sistemos administratorių`,
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn swal-ok-btn',
                  closeModal: true,
                },
              },
            });
          } else {
            res.json().then((r) => {
              // dispatch(actions.backoffice.callSagaForErrHandling(r));

              console.log(r);

              swal({
                title: `${
                  r.ErrorDescription ? r.ErrorDescription : 'Įvyko klaida'
                }`,
                icon: 'error',
                buttons: {
                  confirm: {
                    text: 'Gerai',
                    value: true,
                    visible: true,
                    className: 'btn swal-ok-btn',
                    closeModal: true,
                  },
                },
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsloading(false);
        });
    } else {
      setNotValid(true);
    }
  };
  const onCompanySizeTypeInvegaChange = (val) => {
    setCompanySizeTypeIdInvega(val.target.value);
    console.log(val);
  };

  return (
    open && (
      <div className={styles.container}>
        <div
          className={styles.modal}
          id="modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__title"
          aria-describedby="modal__desc"
        >
          <h2>Verslo subjekto statuso įvedimas</h2>
          <WithSpinner loading={isLoading}>
            <div
              className={styles.inputsContainer}
              style={{ marginTop: '30px' }}
            >
              <select
                disabled={false}
                name="companySizeTypeIdInvega"
                onChange={onCompanySizeTypeInvegaChange}
                value={companySizeTypeIdInvega}
              >
                <option value={null}>{null}</option>
                <option value={1}>Labai maža įmonė</option>
                <option value={2}>Maža įmonė</option>
                <option value={3}>Vidutinė įmonė</option>
                <option value={4}>Didelė įmonė</option>
              </select>
              {notValid && companySizeTypeIdInvega === null && (
                <p className="errorsBlockText error1">
                  Privalote nurodyti verslo subjekto statusą
                </p>
              )}
            </div>
            <div className={styles.btnContainer} style={{ display: 'block' }}>
              <Button type="standart" onClick={() => yes(requestId)}>
                Išsaugoti
              </Button>
              <Button type="cancel" onClick={() => cancel()}>
                Atšaukti
              </Button>
            </div>
          </WithSpinner>
        </div>
      </div>
    )
  );
};

// const mapStateToProps = (state) => ({
//   loading: state.dashboardState.isOnSync,
// });

export default connect()(ChangeCompanySize);
